const AUTH_STORAGE_KEY = 'freelancecrm-auth';

/**
 * True when local storage holds a persisted session (the auth store's key), read without
 * importing the store. The start page uses it to decide between marketing and the app shell;
 * AuthBootstrap uses it to decide whether a marketing page can render before the restore.
 */
export function hasStoredSession(): boolean {
  try {
    const raw = window.localStorage.getItem(AUTH_STORAGE_KEY);
    if (!raw) return false;
    const state = (JSON.parse(raw) as { state?: { user?: unknown; accessToken?: unknown } }).state;
    return Boolean(state?.user || state?.accessToken);
  } catch {
    // Unreadable storage: assume a session may exist so the app shell can sort it out.
    return true;
  }
}
